/* eslint-disable max-lines */
import React from 'react';
import {connect} from 'react-redux';
import {Card, Form} from 'semantic-ui-react';
import {currentDataList} from '../../constants/currentDataAudit';
import '../main/modalOrderInfo/styles.scss';

const HeaderAudit = ({
  currentScreen,
  setCurrentScreen,
  cleanFloatingAuditScreen,
}) => {
  return (
    <Card fluid className='no-space'>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <h3>
            Auditoría de clientes e inventario flotante
          </h3>
          <div className="title-bar-actions-floating">
            <Form.Select
              className='selector-tiny-size small-label-custom'
              placeholder='SELECCIONAR...'
              name='dealer'
              size='mini'
              options={currentDataList}
              value={currentScreen}
              onChange={(e, {value}) => {
                setCurrentScreen(value);
                cleanFloatingAuditScreen();
              }}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default connect(null, {})(HeaderAudit);
